
import { CmhAddressPoint } from '@/models/cmh-address-point';
import { cmhService } from '@/services';
import { OfferingSelectionState } from '@/store/new-connection-cmh/offerings-selection/types';
import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';
import { MutationType } from './mutations';
import { OfferingSelectionOperator, OperatorLight } from '@/models';

export const actions: ActionTree<OfferingSelectionState, RootState> = {
  validate({ commit, getters, state }, address: CmhAddressPoint): boolean {
    if (state?.selections === null) {
      return true
    }

    let change = false
    const subCity = address?.addressPoint?.subCity

    function commitOperator(type: MutationType, payload: OfferingSelectionOperator) {
      switch (type) {
        case MutationType.MUTATION_ADD_OPERATOR:
        case MutationType.MUTATION_REMOVE_OPERATOR:
          commit(type, payload)
          break;
        default:
          throw Error('This mutation is not supported')
      }

      change = true
    }

    if (getters.isElectricitySelected && !cmhService.isElectricManagerOres(subCity)) {
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.electricity)
    }

    if (getters.isGasOresSelected && !cmhService.isGasManagerOres(subCity)) {
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.gas)
    }

    if (getters.isGasResaSelected && !cmhService.isGasManagerResa(subCity)) {
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.resa)
    }


    // If connect my home is not activated, none of the services below are available
    if (!subCity?.connectMyHomeActivated) {
      return !change
    }

    if (getters.isSwdeSelected && !cmhService.isServiceAvailable(subCity, OperatorLight.swde)) {
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.swde)
    }

    if (getters.isProximusSelected && !cmhService.isServiceAvailable(subCity, OperatorLight.proximus)) {
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.proximusAndOrange)
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.proximus)
    }

    if (getters.isOrangeSelected && !cmhService.isServiceAvailable(subCity, OperatorLight.orange)) {
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.proximusAndOrange)
      commitOperator(MutationType.MUTATION_REMOVE_OPERATOR, OfferingSelectionOperator.orange)
    }

    // Add default offering operator for tv, internet, phone
    if (getters.isTvInternetPhoneSelected && !getters.isProximusSelected && !getters.isOrangeSelected) {
      commitOperator(MutationType.MUTATION_ADD_OPERATOR, cmhService.getDefaultTvPhoneInternetOffering(subCity))
    }

    return !change
  }
}
